export const SELECT_PERMISOS = [
  { text: 'Admin', value: 'admin' },
  { text: 'Admin turnos', value: 'adminTurnos' },
  { text: 'Todos los turnos', value: 'verAllTurnos' },
  { text: 'Recepcion', value: 'recep' },
  { text: 'Turnos', value: 'turnos' }
]

export const SELECT_HOTELES = [
  { text: 'Palacete', value: 'P' },
  { text: 'Barcelona', value: 'B' },
  { text: 'Ambos Hoteles', value: 'T' }
]

export const SELECT_ENTRADAS = [
  { text: 'Facturas de clientes', value: 1, type: 'B', operation: '+' }
]

export const SELECT_COBROS = [
  {
    text: 'Prepagos y depósitos a cuenta',
    value: 1,
    type: 'B',
    operation: '+'
  }
]

export const SELECT_PAGOS = [
  {
    text: 'Cancela depósito a cuenta o prepago',
    value: 3,
    type: 'C',
    operation: '-'
  },
  {
    text: 'Factura a crédito',
    value: 2,
    type: 'C',
    operation: '-'
  },
  { text: 'Cobros en efectivo', value: 4, type: 'E', operation: '-' },
  { text: 'Cobros transferencia', value: 5, type: 'F', operation: '-' },
  {
    text: 'Pago recepcion',
    value: 6,
    type: 'H',
    operation: '-'
  }
]

export const TITULOS_CAJA = []

export const SELECT_PUESTOS = [
  { text: 'Recepcionista', value: '1' },
  { text: 'Camarera', value: '2' }
  // { text: 'Obras', value: '3' },
  // { text: 'Despacho', value: '4' },
  // { text: 'Autónomos', value: '5' }
]
